module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels-log_BW-afa70d912af472fe6deade0ec3488aa8.jpg";